import { render, staticRenderFns } from "./PrintTemplateSettings.vue?vue&type=template&id=4d397e9a&scoped=true"
import script from "./PrintTemplateSettings.vue?vue&type=script&lang=js"
export * from "./PrintTemplateSettings.vue?vue&type=script&lang=js"
import style0 from "./PrintTemplateSettings.vue?vue&type=style&index=0&id=4d397e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d397e9a",
  null
  
)

export default component.exports